var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38071 6.37563C1.38071 3.61701 3.61701 1.38071 6.37563 1.38071C9.13425 1.38071 11.3706 3.61701 11.3706 6.37563C11.3706 9.13425 9.13425 11.3706 6.37563 11.3706C3.61701 11.3706 1.38071 9.13425 1.38071 6.37563ZM6.37563 0C2.85447 0 0 2.85447 0 6.37563C0 9.8968 2.85447 12.7513 6.37563 12.7513C7.88753 12.7513 9.2765 12.225 10.3694 11.3457L14.8215 15.7978C15.0911 16.0674 15.5282 16.0674 15.7978 15.7978C16.0674 15.5282 16.0674 15.0911 15.7978 14.8215L11.3457 10.3694C12.225 9.2765 12.7513 7.88753 12.7513 6.37563C12.7513 2.85447 9.8968 0 6.37563 0Z",
    fill: "#0A0E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.1d3587337ced55b07212f6bfc0ae40e3.svg";
export { ForwardRef as ReactComponent };